import React from "react";
import BasicTable from "../../../common/BasicTable/BasicTable";
import { Switch } from "antd";
import Socket from "../../../utils/Socket";
import BarTableActions from "../../../common/BarTableAction/BarTableActions";
import FiltrageWebForm from "./FiltrageWebForm/FiltrageWebForm";
import AddButton from "../../../common/AddButton/AddButton";
import { EquipmentType, ServerLdap } from "../../../types";
import { FiltrageWebType } from "../../../types";
import ContainerRestPage from "../../../common/ContainerRestPage/ContainerRestPage";
import { connect, ConnectedProps } from "react-redux";
import { EntityType } from "../../../types";
import { UserStringFields } from "../../../store/types";
import { changeGlobalStringValue } from "../../../store/actions";
import Collections from "../../../utils/Collections";

const columns = [
    {
        Header: "Nom du filtrage web",
        accessor: "name",
        sort: true,
    },
    {
        Header: "Authentification",
        accessor: "enabled",
        Cell: function cell(row: any) {
            return (
                <p>
                    {row.original.authentification === "Local"
                        ? "Local"
                        : row.original.authentification === "LDAP"
                        ? "Ldap"
                        : "Aucune"}
                </p>
            );
        },
    },
    {
        Header: "État",
        accessor: "enabled",
        Cell: function cell(row: any) {
            return <Switch className=" pull-right" checked={row.original.enabled} disabled={true} />;
        },
    },
];

interface ReduxState {
    collections: {
        Entity: Array<EntityType>;
    };
    global: { entity_id: string; equipment_id: string };
}

const mapStateToProps = (state: ReduxState) => {
    return {
        entities: state.collections.Entity,
    };
};

const mapDispatchToProps = {
    changeGlobalStringValue: (field: UserStringFields, value: string) => changeGlobalStringValue(field, value),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

interface Props {
    entityId: string;
    filtrageWeb: Array<FiltrageWebType>;
    equipments: Array<EquipmentType>;
    entities: EntityType[];
    role: any;
    LDAP: ServerLdap[];
}

interface State {
    selectedItems: Array<string>;
    visibleForm: boolean;
    formType: string;
    categories: Array<any>;
}
class FiltrageWeb extends React.Component<Props, State> {
    constructor(props: any) {
        super(props);
        this.state = {
            selectedItems: [],
            visibleForm: false,
            formType: "",
            categories: [],
        };
    }

    componentDidMount() {
        this.getCategories();
    }

    getCategories = async () => {
        try {
            const res = await Socket.readLean("Categories_filtrageWeb", {}, {});
            this.setState(() => ({ categories: res.data }));
        } catch (e) {
            
        }
    };

    selectItems = (ids: Array<string>) => {
        this.setState(() => ({ selectedItems: ids }));
    };

    openForm = (formType: string, selectedItem?: string): void => {
        if (selectedItem) {
            this.setState(() => ({ visibleForm: true, formType, selectedItems: [selectedItem] }));
        } else {
            this.setState(() => ({ visibleForm: true, formType }));
        }
    };

    addElement = () => {
        this.openForm("create");
    };

    closeEdit = (): void => {
        this.setState(() => ({
            selectedItems: [],
        }));
    };

    closeForm = () => {
        this.setState(() => ({
            visibleForm: false,
            formType: "",
            selectedItems: [],
        }));
    };

    deleteItems = () => {
        const { filtrageWeb } = this.props;
        const { selectedItems } = this.state;
        this.closeEdit();
        if (filtrageWeb && filtrageWeb.length > 0) {
            const entitiesId: Array<string> = filtrageWeb
                .filter((i) => selectedItems.includes(i._id))
                .flatMap((i) => i.entity_id);
            Socket.deleteMany("FiltrageWeb", entitiesId, selectedItems)
        }
    };

    render() {
        const { selectedItems, visibleForm, formType, categories } = this.state;
        const { equipments, filtrageWeb, entityId, role, entities } = this.props;
        const filtrage = Collections.flatRecursive(entities, "FiltrageWeb", [], "");
        
        return (
            <div>
                <div className={"d-flex"}>
                    <h3>Filtrage web</h3>
                    <AddButton str={"un filtrage web"} onClick={this.addElement} role={role} />
                </div>
                <ContainerRestPage>
                    <BasicTable
                        openForm={this.openForm}
                        selectedItems={selectedItems}
                        selectItems={this.selectItems}
                        columns={columns}
                        data={filtrage}
                        tableName={"security__filtrageWeb__table"}
                        role={role}
                    />
                </ContainerRestPage>
                <BarTableActions
                    selectedItems={selectedItems}
                    openForm={this.openForm}
                    deleteItems={this.deleteItems}
                    closeBar={this.closeForm}
                    role={role}
                />
                <FiltrageWebForm
                    equipments={equipments}
                    visible={visibleForm}
                    entityId={entityId}
                    onClose={this.closeForm}
                    selectedItems={selectedItems}
                    formType={formType}
                    filtrageWeb={filtrageWeb}
                    categories={categories}
                    LDAP={this.props.LDAP}
                    role={role}
                />
            </div>
        );
    }
}

export default connector(FiltrageWeb);
